<div class="row">
  <div class="col">
    <h2 class="h2-responsive">Assigned assessments</h2>
    <hr class="mb-3" />
    <div *ngIf="assignments.length == 0">
      <div class="alert alert-warning">No assignments have been made.</div>
      <div class="alert alert-info">
        <p>Assign an assessment, battery of assessments, or a homework assignment by clicking on the item under one of the menu options of Available Batteries, Available Assessments, or Homework. </p>
      </div>
    </div>
    <ul class="list-group">
      <li class="list-group-item flex-column align-items-start" *ngFor="let assignment of assignments">
        <div class="d-flex w-100 justify-content-between">
          <div class="col-12 ml-2">
            <button class="btn btn-primary btn-sm float-right" *ngIf="!assignment.hasStarted"
              (click)="clearAssignment(assignment)">
              <i class='fa fa-trash'></i>
            </button>
            <h5 class="mb-3 d-inline">
              <i class="fa fa-file-text" *ngIf="assignment.type == 'LibraryAsset'"></i>
              <i class="fa fa-clipboard" *ngIf="assignment.type == 'Assessment'"></i>
              <i class="fa fa-folder" *ngIf="assignment.type == 'AssessmentGroup'"></i>
          </h5>
      {{assignment.Name}}
      <div *ngIf="assignment.type == 'AssessmentGroup'" class="mt-2">
              <ul class="list-unstyled ml-4">
                  <li *ngFor="let item of assignment.items">
                      <h5 class="mb-3 d-inline"><i class="fa fa-clipboard"></i></h5>
                          {{item.Name}}
                  </li>
                  <li><hr /></li>
              </ul>
      </div>
      <ul class="list-unstyled ml-4">
          <li><b>Assigned:</b> {{assignment.DateAssigned|date: 'medium'}}</li>
          <li *ngIf="assignment.IsComplete"><b>Completed:</b> {{assignment.DateCompleted|date: 'medium'}}</li>
      </ul>
          </div>
        </div>

      </li>
    </ul>
  </div>
  <div class="col">
    <mdb-tabset #staticTabsAssignments [buttonClass]="'nav-tabs tabs-3 secondary-color'" [contentClass]="'card'"
      class="col-12">
      <mdb-tab heading="Available Batteries">
        <dac-assessment-group-list (buy)="handleBatteryCheckout($event)" (selected)="addAssessmentsFromBattery($event)">
        </dac-assessment-group-list>
      </mdb-tab>
      <mdb-tab heading="Available Assessments">
        <dac-assessment-picker (buy)="handleAssessmentCheckout($event)" (selected)="addAssessment($event)">
        </dac-assessment-picker>
      </mdb-tab>
      <mdb-tab heading="Homework">
        <dac-asset-picker (selected)="addAssetAssignment($event)"></dac-asset-picker>
    </mdb-tab>
    </mdb-tabset>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/client-manage-assignments/client-manage-assignments.component.html